<template>
  <div class="drainage">
    <b-container class="bv-example-row drainage-box">
      <b-row>
        <b-col md="2" sm="4" xs="6" v-for="(item, index) in data" :key="index">
          <img :src="item.img" alt="" />
          <div class="drainage-title">{{ item.title }}</div>
          <div class="drainage-des">
            {{ item.des }}
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style scoped>
.drainage {
  margin: 100px 0;
}
.drainage .drainage-box {
  text-align: center;
  margin-top: 50px;
}
.drainage .drainage-box img {
  width: 50px;
}
.drainage .drainage-box .drainage-title {
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: bold;
  color: #323232;
  line-height: 50px;
}
.drainage .drainage-box .drainage-des {
  font-size: 8px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #323232;
  line-height: 20px;
}
</style>